import { escapeHtml } from "./html";

export type StatusTone = "neutral" | "good" | "warn" | "err";
export type ProgressTone = "neutral" | "success" | "failure";

type StatusViewModel = {
  tone: StatusTone;
  message: string;
  compatibilityWarning: string;
  error: string;
  progressCurrent: number;
  progressTotal: number;
  progressTone: ProgressTone;
};

function formatProgressLabel(current: number, total: number): string {
  return `${current} of ${total} blocks complete`;
}

/** Renders the compact status and progress area. */
export function renderStatusView(status: StatusViewModel): string {
  const progressPercent =
    status.progressTotal > 0
      ? Math.max(0, Math.min(100, (status.progressCurrent / status.progressTotal) * 100))
      : 0;

  return `
    <section class="panel status-panel">
      <img class="status-logo" src="images/Spot_Editor_Logo.png" alt="SPOT Editor logo" />
      <div class="status-content">
        <p class="status-message ${status.tone}">
          <span class="status-label">Status:</span> <span class="status-text">${escapeHtml(status.message)}</span>
        </p>
        ${
          status.compatibilityWarning
            ? `<p class="status-detail">${escapeHtml(status.compatibilityWarning)}</p>`
            : ""
        }
        ${status.error ? `<p class="status-detail error-detail">${escapeHtml(status.error)}</p>` : ""}
        <div class="progress-block">
          <div class="progress-track">
            <div class="progress-fill ${status.progressTone}" style="width: ${progressPercent}%"></div>
          </div>
          ${
            status.progressTotal > 0
              ? `<div class="progress-label">${escapeHtml(formatProgressLabel(status.progressCurrent, status.progressTotal))}</div>`
              : ""
          }
        </div>
      </div>
    </section>
  `;
}
